import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      service: '',
      message: ''
    });
  };

  return (
    <>
      {/* Hero Section */}
      <section className="hero"style={{
          background: `linear-gradient(rgba(13, 63, 105, 0.85), rgba(27, 164, 222, 0.85)), url('/images/mobileapp.png') no-repeat center center/cover`
        }}>
        <div className="container">
          <h1>Contact Us</h1>
          <p>Ready to start your next project? Get in touch with us today and let's create something amazing together.</p>
        </div>
      </section>

      {/* Contact Section - White Background */}
      <section style={{padding: '80px 0', backgroundColor: 'white'}}>
        <div className="container">
          <div className="section-title">
            <h2>Get In Touch</h2>
            <p>We're excited to hear about your project and explore how we can help you achieve your goals.</p>
          </div>
          
          <div className="contact-container" style={{gridTemplateColumns: '1fr 1.2fr', gap: '60px'}}>
            {/* Contact Info - White Card */}
            <div className="contact-info-card" style={{
              backgroundColor: 'white',
              padding: '40px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              border: '1px solid #e9ecef'
            }}>
              <h3 style={{color: 'var(--primary-dark)', marginBottom: '30px'}}>Let's Start a Conversation</h3>
              <p style={{color: 'var(--text-dark)', marginBottom: '30px'}}>Whether you have a project in mind or just want to learn more about our services, we'd love to hear from you.</p>
              
              <div className="contact-details">
                <div className="contact-detail">
                  <div style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'var(--primary-light)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    flexShrink: 0
                  }}>
                    <i className="fas fa-map-marker-alt" style={{color: 'white'}}></i>
                  </div>
                  <div>
                    <h4 style={{color: 'var(--primary-dark)', marginBottom: '5px'}}>Our Office</h4>
                    <p style={{color: 'var(--text-dark)'}}>Nairobi, Kenya</p>
                  </div>
                </div>
                
                <div className="contact-detail">
                  <div style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'var(--primary-light)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    flexShrink: 0
                  }}>
                    <i className="fas fa-phone" style={{color: 'white'}}></i>
                  </div>
                  <div>
                    <h4 style={{color: 'var(--primary-dark)', marginBottom: '5px'}}>Call Us</h4>
                    <p style={{color: 'var(--text-dark)'}}>+254 705 653 953</p>
                  </div>
                </div>
                
                <div className="contact-detail">
                  <div style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'var(--primary-light)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    flexShrink: 0
                  }}>
                    <i className="fas fa-envelope" style={{color: 'white'}}></i>
                  </div>
                  <div>
                    <h4 style={{color: 'var(--primary-dark)', marginBottom: '5px'}}>Email Us</h4>
                    <p style={{color: 'var(--text-dark)'}}>hello@zanifytech.com</p>
                  </div>
                </div>
                
                <div className="contact-detail">
                  <div style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'var(--primary-light)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    flexShrink: 0
                  }}>
                    <i className="fas fa-clock" style={{color: 'white'}}></i>
                  </div>
                  <div>
                    <h4 style={{color: 'var(--primary-dark)', marginBottom: '5px'}}>Business Hours</h4>
                    <p style={{color: 'var(--text-dark)'}}>Mon - Fri: 8:00 AM - 6:00 PM EAT</p>
                  </div>
                </div>
              </div>
              
              <div style={{marginTop: '30px'}}>
                <h4 style={{color: 'var(--primary-dark)', marginBottom: '15px'}}>Follow Us</h4>
                <div className="social-links">
                  <a href="#" style={{backgroundColor: 'var(--primary-light)'}}><i className="fab fa-linkedin-in"></i></a>
                  <a href="#" style={{backgroundColor: 'var(--primary-light)'}}><i className="fab fa-twitter"></i></a>
                  <a href="#" style={{backgroundColor: 'var(--primary-light)'}}><i className="fab fa-facebook-f"></i></a>
                  <a href="#" style={{backgroundColor: 'var(--primary-light)'}}><i className="fab fa-instagram"></i></a>
                </div>
              </div>
            </div>

            {/* Contact Form - White Card with Accent */}
            <div className="contact-form" style={{
              backgroundColor: 'white',
              padding: '40px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              border: '1px solid #e9ecef',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Accent Border */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '4px',
                background: 'linear-gradient(135deg, var(--primary-dark) 0%, var(--primary-light) 100%)'
              }}></div>
              
              <h3 style={{color: 'var(--primary-dark)', marginBottom: '30px'}}>Send us a Message</h3>
              
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name" style={{color: 'var(--text-dark)', fontWeight: '600'}}>Your Name *</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name"
                    className="form-control" 
                    value={formData.name}
                    onChange={handleChange}
                    required 
                    style={{border: '1px solid #ddd', borderRadius: '4px'}}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email" style={{color: 'var(--text-dark)', fontWeight: '600'}}>Your Email *</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email"
                    className="form-control" 
                    value={formData.email}
                    onChange={handleChange}
                    required 
                    style={{border: '1px solid #ddd', borderRadius: '4px'}}
                  />
                </div>
                
                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
                  <div className="form-group">
                    <label htmlFor="phone" style={{color: 'var(--text-dark)', fontWeight: '600'}}>Phone Number</label>
                    <input 
                      type="tel" 
                      id="phone" 
                      name="phone"
                      className="form-control" 
                      value={formData.phone}
                      onChange={handleChange}
                      style={{border: '1px solid #ddd', borderRadius: '4px'}}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="company" style={{color: 'var(--text-dark)', fontWeight: '600'}}>Company</label>
                    <input 
                      type="text" 
                      id="company" 
                      name="company"
                      className="form-control" 
                      value={formData.company}
                      onChange={handleChange}
                      style={{border: '1px solid #ddd', borderRadius: '4px'}}
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="service" style={{color: 'var(--text-dark)', fontWeight: '600'}}>Service Interested In</label>
                  <select 
                    id="service" 
                    name="service"
                    className="form-control" 
                    value={formData.service}
                    onChange={handleChange}
                    style={{border: '1px solid #ddd', borderRadius: '4px'}}
                  >
                    <option value="">Select a service</option>
                    <option value="mobile-app">Mobile App Development</option>
                    <option value="web-app">Web Application Development</option>
                    <option value="website">Website Development</option>
                    <option value="uiux">UI/UX Design</option>
                    <option value="consulting">Consulting</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message" style={{color: 'var(--text-dark)', fontWeight: '600'}}>Project Details *</label>
                  <textarea 
                    id="message" 
                    name="message"
                    className="form-control" 
                    value={formData.message}
                    onChange={handleChange}
                    required
                    style={{border: '1px solid #ddd', borderRadius: '4px', minHeight: '120px'}}
                  ></textarea>
                </div>
                
                <button type="submit" className="btn" style={{
                  background: 'linear-gradient(135deg, var(--primary-dark) 0%, var(--primary-light) 100%)',
                  color: 'white',
                  border: 'none',
                  width: '100%',
                  padding: '15px',
                  fontSize: '1.1rem',
                  fontWeight: '600'
                }}>
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section style={{
        padding: '60px 0',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
      }}>
        <div className="container">
          <div className="section-title">
            <h2>Why Work With Us?</h2>
            <p>Discover what makes us Nairobi's leading mobile app development company</p>
          </div>
          
          <div className="services-grid">
            <div className="service-card" style={{textAlign: 'center'}}>
              <div className="service-icon">
                <i className="fas fa-rocket" style={{color: 'var(--primary-light)'}}></i>
              </div>
              <h3>Fast Delivery</h3>
              <p>We deliver high-quality solutions within agreed timelines without compromising on quality.</p>
            </div>
            
            <div className="service-card" style={{textAlign: 'center'}}>
              <div className="service-icon">
                <i className="fas fa-headset" style={{color: 'var(--primary-light)'}}></i>
              </div>
              <h3>24/7 Support</h3>
              <p>We provide ongoing support and maintenance to ensure your solution performs optimally.</p>
            </div>
            
            <div className="service-card" style={{textAlign: 'center'}}>
              <div className="service-icon">
                <i className="fas fa-shield-alt" style={{color: 'var(--primary-light)'}}></i>
              </div>
              <h3>Quality Guaranteed</h3>
              <p>We follow industry best practices and rigorous testing to deliver bug-free solutions.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to Start Your Project?</h2>
          <p>Let's discuss your requirements and create a custom solution that drives your business forward.</p>
          <div style={{display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap'}}>
            <a href="/contact" className="btn">Get Free Consultation</a>
            <a href="tel:+254705653953" className="btn btn-secondary">
              <i className="fas fa-phone"></i> Call Now
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;